module.exports = __webpack_public_path__ + "static/media/calendar.f182a78f.svg";